import { InputText as Input } from "primereact/inputtext"
import { Chips } from "primereact/chips"
import { trimTextValue } from "../../../components/FieldTypes/helpers/trimTextValue"

// Styles
import styles from "../../../styles/Form.module.css"

export default function handleFieldConditional(formik) {
  if (!formik.values.field_conditional) return null
  return (
    <div
      style={{
        backgroundColor: "#f7f7f7",
        width: "fit-content",
        padding: 15,
        marginBottom: 30,
      }}
      className={styles.form}
    >
      <div className={styles.field}>
        <label className={styles.label}>Field Name:</label>
        <Input
          name="field_conditional_key"
          onChange={(e) => formik.handleChange(trimTextValue(e))}
          onBlur={formik.handleBlur}
          value={formik.values.field_conditional_key}
          className={styles.value}
        />
        {formik.touched.field_conditional_key &&
          formik.errors.field_conditional_key && (
            <div className={styles.errFieldMsg}>
              {formik.errors.field_conditional_key}
            </div>
          )}
      </div>
      <div className={styles.field}>
        <label className={styles.label}>Field Condition:</label>
        <div style={{ fontSize: 11 }}>
          Enter Option(s) for conditional field. Each Option entered should be
          followed by a comma.
        </div>
        <Chips
          name="field_conditional_value"
          separator=","
          value={formik.values.field_conditional_value}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          className={styles.value}
        />
      </div>
    </div>
  )
}
